import React from 'react';
import { useHistory } from 'react-router-dom';

interface BackButtonProps {
  to?: string;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ to = '/', className }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(to);
  };

  return (
    <button
      onClick={handleClick}
      className={`back-button-inline ${className ? ` ${className}` : ''}`}
    >
      <svg
        className='w-5 h-5'
        fill='none'
        stroke='currentColor'
        viewBox='0 0 24 24'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M15 19l-7-7 7-7'
        />
      </svg>
    </button>
  );
};

export default BackButton;
